import {useEffect, useMemo, useRef} from 'preact/hooks';
import dataLayer from '@upi/data-layer';
import {CommerceItemLists} from '@upi/data-layer-constants';

export function getVisibleReorderProducts ( queryGroups = [], resultGroups = [], query = '' ) {
    const products = [];
    let renderedPosition = 0;

    queryGroups.forEach( ( queryGroup, groupIndex ) => {
        const resultGroup = resultGroups[groupIndex] || {};
        const hidden = typeof queryGroup.hideIf === 'function' &&
            queryGroup.hideIf( query, resultGroups );

        if ( hidden ) {
            return;
        }

        const results = resultGroup.results || [];
        const resultLimit = resultGroup.resultLimit || results.length;
        const pageIndex = resultGroup.pageIndex || 0;
        const visibleResultCount = resultLimit * (pageIndex + 1);

        results.forEach( ( result, resultIndex ) => {
            renderedPosition += 1;
            if ( resultIndex < visibleResultCount && queryGroup.analyticsProducts && result.sku ) {
                products.push( {...result, position: renderedPosition} );
            }
        } );
    } );

    return products;
}

export function ReorderItemLookupAnalytics ( {isActive, queryGroups, resultGroups, query} ) {
    const products = useMemo(
        () => isActive ? getVisibleReorderProducts( queryGroups, resultGroups, query ) : [],
        [isActive, queryGroups, resultGroups, query]
    );
    const signature = `${query}|${products.map( product => `${product.sku}:${product.position}` ).join( '|' )}`;
    const previousSignature = useRef( null );

    useEffect( () => {
        if ( products.length && signature !== previousSignature.current ) {
            dataLayer.product.sendProductListView( products, CommerceItemLists.REORDER );
            previousSignature.current = signature;
        }
    }, [products, signature] );

    return null;
}
